import React from "react";
import AddBadge from "./AddBadge";
import FeaturedDropdown from "./FeaturedDropdown";

const CreateExtraFeatureOptions = () => {
  return (
    <div className="mt-4 mb-10 w-[934px] border border-solid border-inputBorder px-7 pt-7">
      <div className="flex flex-col gap-2">
        <FeaturedDropdown title={"Category Page"} />
        <FeaturedDropdown
          title={"Category Page Featured"}
          dropdown={true}
          price={50}
        />
        <FeaturedDropdown
          title={"Home Page Featured"}
          dropdown={true}
          price={70}
        />{" "}
        <FeaturedDropdown
          title={"Home Page Slider Gallery"}
          dropdown={true}
          price={50}
        />
      </div>
      <div className="mb-12 mt-11 flex flex-col gap-10">
        <AddBadge text={"For Sale"} price={5.0} />
        <AddBadge text={"Bergain"} price={5.0} />
        <AddBadge text={"Rent me"} price={5.0} />
        <AddBadge text={"Look Here"} price={5.0} />
        <AddBadge text={"Buy me"} price={5.0} />
        <AddBadge text={"Best Deal"} price={5.0} />
      </div>
    </div>
  );
};

export default CreateExtraFeatureOptions;
